import { Link } from "react-router";
import { useSitzung } from "../sitzung";
import { Meldung } from "../ui/Leer";
import { Wortmarke } from "../ui/Wortmarke";
import s from "./seiten.module.css";

/** Datenschutzhinweis der App (BAUPLAN-ABSCHLUSS.md, Abschnitt 8). Öffentlich, auch ohne Anmeldung, verlinkt in Anmeldung,
 *  Willkommen und Profil. Entwurf: Was nicht feststeht, steht in eckigen Klammern. Keine Rechtsberatung, der Vorstand gibt frei. */
export function Datenschutz() {
  const { sitzung } = useSitzung();
  const zurueck = sitzung.status === "angemeldet" ? { to: "/profil", text: "Zurück zum Profil" } : { to: "/anmelden", text: "Zur Anmeldung" };

  return (
    <main className={s.datenschutz}>
      <div className={s.datenschutzKopf}>
        <Wortmarke />
        <Link to={zurueck.to}>{zurueck.text}</Link>
      </div>
      <h1>Datenschutz in der obsn App.</h1>
      <Meldung>Entwurf vom 13.10.2026, ergänzt am 15.10.2026 (zuletzt: Dateien und Line-up in Vorhaben). Der Vorstand prüft und gibt frei. Was noch offen ist, steht in eckigen Klammern.</Meldung>

      <h2>Wer verantwortlich ist</h2>
      <p>
        obsn e.V., Ossenreyerstraße 20-22, 18439 Stralsund, vertreten durch den Vorstand. Kontakt für Datenschutz: <a href="mailto:info@obsn.de">info@obsn.de</a>.
      </p>

      <h2>Wofür es die App gibt</h2>
      <p>
        app.obsn.de ist der interne Arbeitsbereich des Vereins: Aufgaben und Sprints, Sitzungen und Protokolle, Termine, Ablage, Newsletter und Website. Zugang hat nur, wen
        ein Admin eingeladen hat.
      </p>

      <h2>Welche Daten die App verarbeitet</h2>
      <ul>
        <li>
          <strong>Zugang:</strong> E-Mail-Adresse, Vorname, Nachname, Aufgabe im Verein, Rolle (Mitglied oder Vorstand), Admin ja oder nein, aktiv ja oder nein, Zeitpunkt der
          ersten Anmeldung. Freiwillig ein Foto.
        </li>
        <li>
          <strong>Anmeldung:</strong> Du meldest dich mit einem Code an, den die App an deine E-Mail-Adresse schickt. Ein Passwort gibt es nicht. Dein Browser speichert die
          Anmeldung im eigenen Speicher des Browsers, kein Cookie: auf Wunsch 30 Tage, sonst bis du den Tab schließt. Der Anmeldedienst protokolliert Anmeldungen [Umfang und
          Dauer laut Supabase ergänzen].
        </li>
        <li>
          <strong>Aufgaben:</strong> Titel, Beschreibung, Frist, Status mit freiwilligem Grund, Priorität, Verantwortliche, Unteraufgaben und Links. Kommentare mit
          Erwähnungen. Zu jeder Änderung speichert die App, wer was wann geändert hat (Verlauf).
        </li>
        <li>
          <strong>Vorhaben:</strong> Name, Beschreibung, Zeitraum, Link zum Drive-Ordner und die Personen darin, mit Rolle, seit wann und wer sie dazugeholt hat.
          Dazu das Budget (Posten mit Plan und vorläufigem Ist), Unterlagen wie Pläne, Angebote, Verträge und Plakate als Datei oder Link und das Line-up (Acts mit
          Zeit, Bühne und Status, ohne Kontaktdaten).
        </li>
        <li>
          <strong>Sitzungen:</strong> Anwesende, Gäste als Text, Tagesordnung, Beschlüsse, Notizen und das Protokoll.
        </li>
        <li>
          <strong>Mitteilungen:</strong> was die App dir mitteilt, in der App, per Mail und als Push, dazu deine Einstellungen je Anlass.
        </li>
        <li>
          <strong>Geräte für Push</strong> (erst, wenn Push eingerichtet ist und du es auf deinem Gerät erlaubst): die Adresse, über die der Push-Dienst deines Geräts die
          Nachricht zustellt, und die Schlüssel dafür.
        </li>
        <li>
          <strong>Redaktion:</strong> Entwürfe der Newsletter und Inhalte der Website, mit Verlauf.
        </li>
      </ul>
      <p>Mitgliederdaten wie Anschrift, Bankdaten und Beiträge bleiben in easyVerein. Die volle IBAN steht nie in der App.</p>

      <h2>Wer was sieht</h2>
      <ul>
        <li>Alle mit Zugang sehen Namen, Aufgabe im Verein und Fotos der anderen, ihre eigenen Aufgaben und Aufgaben „Alle Mitglieder“.</li>
        <li>Wer in einem Vorhaben ist, sieht dazu dieses Vorhaben und seine Aufgaben „Kapsel“, mehr dazu unter „Vorhaben (Kapseln)“.</li>
        <li>Der Vorstand sieht dazu Aufgaben „Nur Vorstand“, Termine, Sitzungen, Protokolle und Ablage.</li>
        <li>Admins sehen die E-Mail-Adressen und verwalten die Zugänge. Ein Admin ohne Vorstandsrolle sieht keine Vorstandsthemen.</li>
        <li>Wer verantwortlich ist, sieht die Aufgabe immer.</li>
        <li>Technisch Zugriff auf die ganze Datenbank haben [Personen mit Zugang zum Dashboard von Supabase].</li>
      </ul>

      <h2>Vorhaben (Kapseln)</h2>
      <p>
        Ein Vorhaben bündelt Aufgaben und Personen für eine Veranstaltung oder einen Bereich des Vereins. So arbeiten Mitglieder an einer Sache mit, ohne dass alle
        Mitglieder alles sehen.
      </p>
      <ul>
        <li>
          <strong>Wer Vorhaben verwaltet:</strong> Der Vorstand legt Vorhaben an, bearbeitet und archiviert sie und bestimmt die Leitung. Vorstand und Leitung holen weitere
          Personen mit Zugang dazu, als Leitung oder mitwirkend, ändern ihre Rolle und nehmen sie wieder heraus.
        </li>
        <li>
          <strong>Wer ein Vorhaben sieht:</strong> Der Vorstand sieht alle Vorhaben. Alle anderen, auch Admins ohne Vorstandsrolle, sehen nur die Vorhaben, in denen sie
          selbst sind, auch archivierte. Sie sehen Name, Beschreibung, Zeitraum und wer mit welcher Rolle dabei ist, seit wann und wer die Person dazugeholt hat.
        </li>
        <li>
          <strong>Aufgaben „Kapsel“:</strong> Sie sehen der Vorstand, alle Personen des Vorhabens, die Verantwortlichen und wer die Aufgabe angelegt hat, jeweils mit
          Kommentaren und Verlauf. Andere Mitglieder sehen sie nicht.
        </li>
        <li>
          <strong>Andere Aufgaben im Vorhaben:</strong> Aufgaben „Alle Mitglieder“ sehen alle mit Zugang, wie jede Aufgabe für alle. Aufgaben „Nur Vorstand“ sehen die
          Personen des Vorhabens nicht, auch die Leitung nicht, außer sie sind dort verantwortlich oder haben die Aufgabe angelegt.
        </li>
        <li>
          <strong>Mitteilungen:</strong> Wer in ein Vorhaben geholt wird oder eine andere Rolle bekommt, erhält eine Mitteilung in der App mit dem Namen des Vorhabens und
          der Person, die das getan hat. Eine Mail gibt es dafür nicht. Ein Push, falls du ihn eingerichtet hast, sagt nur „Du bist in einem Vorhaben dabei.“ Beim
          Herausnehmen gibt es keine Mitteilung. Pushs zu Aufgaben „Kapsel“ nennen keinen Titel.
        </li>
        <li>
          <strong>Slack:</strong> Neuigkeiten zu Aufgaben „Kapsel“ erscheinen im Vorstandskanal mit Vornamen, Status und Link, ohne Titel, außer der Vorstand hat Titel
          vertraulicher Aufgaben für Slack freigegeben. Wer in ein Vorhaben kommt oder herausgenommen wird, steht nicht in Slack.
        </li>
        <li>
          <strong>Budget und Unterlagen:</strong> Das Budget eines Vorhabens und Unterlagen, die als „nur Leitung“ markiert sind, sehen nur der Vorstand und die
          Leitung. Angebote, Verträge, Rechnungen und Förderanträge sind immer „nur Leitung“, die übrigen Unterlagen sehen auch Mitwirkende. Das Ist im Budget ist
          vorläufig, Bankdaten stehen nicht in der App.
        </li>
        <li>
          <strong>Dateien:</strong> Vorstand und Leitung laden Unterlagen als Datei hoch (PDF, Bilder, Word, Excel, bis 10 MB). Die Dateien liegen im Speicher der App
          bei Supabase in Frankfurt am Main, in einem Bereich, den nur die App erreicht. Sehen kann eine Datei nur, wer die Unterlage sehen darf: Personen des
          Vorhabens und der Vorstand, Dateien mit „nur Leitung“ nur Vorstand und Leitung. Es gibt keine öffentlichen Links. Statt einer Datei geht weiter ein Link,
          etwa zu einem Ordner in Google Drive; wer ihn öffnen kann, regelt die Freigabe dort. Die App ist Arbeitsablage, kein Archiv: Belege bewahrt der Verein in
          der Buchhaltung auf, nicht in der App.
        </li>
        <li>
          <strong>Line-up:</strong> Acts mit Zeit, Bühne, Beschreibung und Status sehen alle Personen des Vorhabens, ändern Vorstand und Leitung. Die Gage steht im
          Budget und ist nur für Vorstand und Leitung sichtbar. Kontaktdaten von Künstlern speichert die App nicht.
        </li>
        <li>
          <strong>Verlauf:</strong> Die App hält fest, wer wen wann dazugeholt, die Rolle geändert oder herausgenommen und wer Budget, Unterlagen oder Line-up geändert
          hat.
          Diesen Verlauf sieht der Vorstand.
        </li>
        <li>
          <strong>Herausnehmen und Deaktivieren:</strong> Wer aus einem Vorhaben genommen oder deaktiviert wird, sieht das Vorhaben und seine Aufgaben „Kapsel“ nicht
          mehr. Ausgenommen sind Aufgaben, für die die Person verantwortlich ist oder die sie angelegt hat.
        </li>
        <li>
          <strong>Wie lange:</strong> Ist ein Vorhaben vorbei, archiviert es der Vorstand. Zwei Jahre nach dem Archivieren löscht die App das Vorhaben mit seinen Personen,
          Rollen, Aufgaben, Budget, Unterlagen, Dateien, Line-up und dem Verlauf. Wer vorher herausgenommen wird, steht bis dahin nur noch im Verlauf. Eine entfernte
          Unterlage oder eine ersetzte Version löscht die App mit der Datei, spätestens am nächsten Tag.
        </li>
      </ul>

      <h2>Zweck und Rechtsgrundlage</h2>
      <p>Zweck ist die Organisation der Vereinsarbeit. Rechtsgrundlage: [vom Vorstand zu prüfen und festzulegen].</p>

      <h2>Dienstleister</h2>
      <ul>
        <li>
          <strong>Supabase:</strong> Datenbank, Anmeldung und Speicher für Fotos. Anbieter ist die Supabase Pte. Ltd., Serverstandort Frankfurt am Main. Es ist dieselbe
          Datenbank wie für die Formulare auf obsn.de. Für Übermittlungen außerhalb der EU gelten Standardvertragsklauseln der EU-Kommission. [Anschrift und Vertrag zur
          Auftragsverarbeitung ergänzen.]
        </li>
        <li>
          <strong>Netlify:</strong> stellt die App bereit, die Funktionen der App laufen in Frankfurt am Main. Anbieter ist die Netlify, Inc., 101 2nd Street, San
          Francisco, CA 94105, USA. Netlify nimmt am EU-US Data Privacy Framework teil und nutzt zusätzlich Standardvertragsklauseln der EU-Kommission. Mit Netlify besteht
          ein Vertrag zur Auftragsverarbeitung.
        </li>
        <li>
          <strong>Resend:</strong> verschickt die Mails der App (Anmeldecode, Mitteilungen) über Server in der EU (Irland). Anbieter ist die Plus Five Five, Inc., 2261
          Market Street #5039, San Francisco, CA 94114, USA. Mit dem Anbieter besteht ein Vertrag zur Auftragsverarbeitung mit Standardvertragsklauseln der EU-Kommission.
        </li>
        <li>
          <strong>Slack:</strong> Ereignisse erscheinen im Vorstandskanal #7_vorstand, nur mit Titel, Vornamen, Status und Link. Kommentare und Erwähnungen gehen nie nach
          Slack. [Anbieter, Anschrift und Grundlage ergänzen.]
        </li>
        <li>
          <strong>Push-Dienste</strong> der Hersteller deines Geräts (zum Beispiel Apple, Google, Mozilla), erst mit Push: kurze, neutrale Texte, verschlüsselt.
        </li>
      </ul>

      <h2>Wie lange die App speichert</h2>
      <ul>
        <li>Mitteilungen: 90 Tage, dann löscht die App sie.</li>
        <li>Archivierte Vorhaben: zwei Jahre nach dem Archivieren, mit Personen, Rollen, Aufgaben, Budget, Unterlagen, Dateien, Line-up und Verlauf.</li>
        <li>
          Aufgaben, Kommentare und Verlauf: 12 Monate nach dem Erledigen oder Löschen, dann löscht die App sie endgültig. Gelöschte Aufgaben lassen sich bis dahin
          wiederherstellen. Aufgaben eines Vorhabens werden mit dem Vorhaben gelöscht.
        </li>
        <li>Protokolle: [Frist laut Satzung und Geschäftsordnung].</li>
        <li>Geräte für Push: bis du Push abschaltest, spätestens 12 Monate nach der letzten Nutzung.</li>
        <li>
          Zugang: Wer nicht mehr mitarbeitet, wird deaktiviert und kann sich nicht mehr anmelden. 12 Monate nach der Deaktivierung löscht die App das Konto, das Foto,
          die Mitteilungen und die Einstellungen. In Aufgaben, Kommentaren und im Verlauf steht dann statt des Namens „Ehemalige Person“.
        </li>
      </ul>

      <h2>Keine Werbung, kein Tracking</h2>
      <p>Die App setzt keine Cookies, keine Werbedienste und keine Analyse ein. Die Schriften sind Teil der App und werden nicht von fremden Servern geladen.</p>

      <h2>Deine Rechte</h2>
      <p>
        Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Namen, Aufgabe im Verein und Foto änderst
        du selbst im Profil. Für alles andere schreib an <a href="mailto:info@obsn.de">info@obsn.de</a>. Du kannst dich bei einer Aufsichtsbehörde beschweren, zum Beispiel beim
        Landesbeauftragten für Datenschutz und Informationsfreiheit Mecklenburg-Vorpommern in Schwerin.
      </p>
    </main>
  );
}
